export * from './lessons.module';

export { LessonsComponent } from './components/lessons.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/lessons/index.ts